/* eslint-disable import/prefer-default-export */
import Vue from 'vue';

export const ripple = new Vue({
  methods: {
    ripples() {
      /* eslint-disable no-multi-assign */

      const links = document.querySelectorAll('.ripplelink');

      for (let i = 0, len = links.length; i < len; i++) {
        links[i].addEventListener(
          'click',
          (e) => {
            const targetEl = e.target;
            let inkEl = targetEl.querySelector('.ink');
            console.log('Rippleddd');
            if (inkEl) {
              inkEl.classList.remove('animate');
            } else {
              inkEl = document.createElement('span');
              inkEl.classList.add('ink');
              inkEl.style.width = inkEl.style.height = `${Math.max(
                targetEl.offsetWidth,
                targetEl.offsetHeight,
              )}px`;
              targetEl.appendChild(inkEl);
            }

            inkEl.style.left = `${e.offsetX - inkEl.offsetWidth / 2}px`;
            inkEl.style.top = `${e.offsetY - inkEl.offsetHeight / 2}px`;
            inkEl.classList.add('animate');
          },
          false,
        );
      }
    },
  },
});
